<label class="top">
    <app-tooltip *ngIf="tooltipText" record="{{tooltipText}}"></app-tooltip>
    {{ topLabel }}</label>
<label class="off">{{ offLabel }}</label>
<p-inputSwitch class="switch"
               [disabled]="disabled"
               [(ngModel)]="value"
               (ngModelChange)="onChange($event)">
</p-inputSwitch>
<label class="on" [class.enabled]="value">{{ onLabel }}</label>
